import WeeklyChallengeBase from "./WeeklyChallengeBase";

export default function WeeklyMathematicsChallenge() {
  return (
    <WeeklyChallengeBase
      examType="SUBJECT_PRACTICE"
      subjectId={2}   // ✅ Mathematics ONLY
      title="📐 Weekly Mathematics Challenge"
      subtitle="Compete using Mathematics subject practice • Rankings reset every week"
    />
  );
}
